import { IStoreState } from '../types';
import {get} from 'lodash';

export const getCompetitionScreen = (state: IStoreState) => {
	const required_screen_to_show = get(state, 'competition.required_screen_to_show', false);
	return required_screen_to_show || get(state, 'competition.screen_to_show', '');
};